import React, { createContext, useContext } from 'react';

import { useRootStore } from '@/configs/store';
import { useGlobalUserFilterModel } from '@/features/globalUserFilter';
import { useLogsMode } from '@/features/logsMode';
import { useLocalStore } from '@/hooks/useLocalStore';

import { TimeLogStore } from './TimeLogStore';

interface ProviderProps {
  children: React.ReactNode;
}

const TimeLogStoreContext = createContext<TimeLogStore | null>(null);

export const TimeLogStoreProvider: React.FC<ProviderProps> = ({ children }) => {
  const usersFilterStore = useGlobalUserFilterModel();
  const { alertsStore, userStore, queryStore } = useRootStore();
  const mode = useLogsMode();

  const timeLogStore = useLocalStore(
    () =>
      new TimeLogStore({
        userStore,
        usersFilterModel: usersFilterStore,
        alertsStore,
        queryStore,
        mode,
      }),
  );

  return (
    <TimeLogStoreContext.Provider value={timeLogStore.store}>
      {children}
    </TimeLogStoreContext.Provider>
  );
};

export function useTimeLogStore() {
  const store = useContext(TimeLogStoreContext);

  if (!store) throw new Error('useTimeLogStore must be used within TimeLogStoreProvider');

  return store;
}
